import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { Bell, Check, ExternalLink } from "lucide-react";

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/notifications")
      .then((r) => {
        setNotifications(r.data.items || []);
        setUnread(r.data.unread || 0);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const markAllRead = async () => {
    try {
      await api.post("/notifications/mark-read");
      toast.success("All notifications marked as read");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div className="p-10 max-w-4xl mx-auto">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-400">System</p>
          <h1 className="font-heading text-3xl font-bold mt-2 tracking-tight">Notifications</h1>
          <p className="text-zinc-500 mt-2 text-sm">
            {unread > 0 ? `${unread} unread notification${unread > 1 ? "s" : ""}` : "All caught up"}
          </p>
        </div>
        {unread > 0 && (
          <button onClick={markAllRead}
            className="inline-flex items-center gap-2 bg-zinc-950 text-white px-5 py-2.5 rounded-md text-sm font-medium hover:bg-zinc-800 transition-colors">
            <Check size={15} /> Mark all read
          </button>
        )}
      </div>

      {loading ? (
        <div className="mt-10 text-sm text-zinc-400">Loading...</div>
      ) : notifications.length === 0 ? (
        <div className="mt-10 border-2 border-dashed border-zinc-200 rounded-lg p-16 text-center text-zinc-400">
          <Bell size={26} className="mx-auto mb-3" />
          <p className="text-sm">No notifications yet.</p>
        </div>
      ) : (
        <div className="mt-8 border border-zinc-200 bg-white rounded-lg overflow-hidden">
          {notifications.map((n) => (
            <div key={n.id} className={`px-6 py-4 border-b border-zinc-50 flex items-start gap-4 ${!n.read ? "bg-blue-50/30" : ""}`}>
              <div className={`mt-1 w-2 h-2 rounded-full shrink-0 ${!n.read ? "bg-blue-500" : "bg-transparent"}`} />
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${!n.read ? "font-medium" : "text-zinc-600"}`}>{n.message}</p>
                <p className="text-xs text-zinc-400 mt-1">
                  {n.created_at ? new Date(n.created_at).toLocaleString() : ""}
                </p>
              </div>
              {n.link && (
                <a href={n.link} className="shrink-0 p-1.5 hover:bg-zinc-100 rounded-md text-zinc-400 hover:text-zinc-700">
                  <ExternalLink size={14} />
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
